import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import MainMenu from "./MainMenu";
import Submenus from "./Submenus";
import { Link } from "react-router-dom";
import API_URL from "../../config.js";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";
// import LanguageDropdown from "../utility/LanguageDropdown.jsx";

const Navbar = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [subMenuItems, setSubMenuItems] = useState([]);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    axios
      .get(`${API_URL}/layout/header`)
      .then((response) => {
        setMenuItems(response.data?.Menu || []);
        setSubMenuItems(response?.data?.Submenu || []);
      })
      .catch((error) => {
        console.error("Error fetching menu data:", error);
      });

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleServicesClick = () => {
    setShowSubMenu(!showSubMenu);
  };

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm sticky-top">
      <Header />
      <nav className="">
        <div className="container d-flex align-items-center justify-content-between">
          {/* {isMobile && <LanguageDropdown />} */}

          <Link
            className="navbar-brand"
            to="/"
            // style={{
            //   marginLeft: "1.5rem",
            // }}
          >
            <img
              src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/08/New-Logo-Elite-Body-Home-01.png"
              alt="Logo"
              className="img-fluid"
              style={{ width: "185px", height: "70px" }}
            />
          </Link>

          {isMobile && (
            <button
              className="navbar-toggler border-0 bg-transparent"
              type="button"
              onClick={toggleMobileMenu}
              aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
              style={{ marginLeft: "4rem" }}
            >
              {isMobileMenuOpen ? (
                <FaTimes className="fs-1" aria-hidden="true" />
              ) : (
                <GiHamburgerMenu className="fs-1" aria-hidden="true" />
              )}
            </button>
          )}

          {/* Desktop Menu */}
          {!isMobile && (
            <MainMenu
              menuItems={menuItems}
              onServicesClick={handleServicesClick}
              subMenuItems={subMenuItems}
            />
          )}
        </div>
      </nav>

      {/* Desktop Submenu */}
      {showSubMenu && !isMobile && (
        <div
          className="container-fluid shadow-md"
          style={{
            backgroundColor: "#f0f0f0",
          }}
        >
          <Submenus subMenuItems={subMenuItems} />
        </div>
      )}

      {/* Mobile Menu Drawer */}
      {isMobile && (
        <div
          className={`mobile-menu-drawer ${isMobileMenuOpen ? "open" : ""}`}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "white",
            zIndex: 1000,
            transform: isMobileMenuOpen ? "translateX(0)" : "translateX(-100%)",
            transition: "transform 0.3s ease-in-out",
            // padding: "20px",
            // paddingTop: "100px",
            overflowY: "auto",
            marginTop: "70px",
          }}
        >
          <MainMenu
            menuItems={menuItems}
            onServicesClick={handleServicesClick}
            subMenuItems={subMenuItems}
            toggleMobileMenu={toggleMobileMenu}
            isMobile={isMobile}
          />
        </div>
      )}
    </header>
  );
};

export default Navbar;
